import { IntegrationType, NonSensitiveFlightRecordConnectedAccount } from "@nova/schemas"
import { FC } from "react"
import { ConnectedAccountIntegrationSectionAutel } from "./sections/ConnectedAccountIntegrationSectionAutel"
import { ConnectedAccountIntegrationSectionSkydio } from "./sections/ConnectedAccountIntegrationSectionSkydio"
import { ConnectedAccountIntegrationSectionDji } from "./sections/ConnectedAccountIntegrationSectionDji"

type IntegrationSectionMap = {
    [K in IntegrationType]?: FC<{ accounts: NonSensitiveFlightRecordConnectedAccount<K>[] }>
}

export const integrationSectionByIntegrationType: IntegrationSectionMap = {
    [IntegrationType.dji]: ConnectedAccountIntegrationSectionDji,
    [IntegrationType.autel]: ConnectedAccountIntegrationSectionAutel,
    [IntegrationType.skydio]: ConnectedAccountIntegrationSectionSkydio,
}
